<template>
  <!-- 排行榜列表 -->
  <div id="ranking">
    <div v-for="(item,index) in rankListChild" :key="index" class="listitem" @click="getDetail(item, ranklist.type)">
        <span v-if="ranklist.type <= 2" class="indexpoint" :class="{isone:index==0,istwo:index==1,isthree:index==2,}">{{index + 1}}</span>
        <div class="name" :class="{activebuild: ranklist.type=='3', activehealth: ranklist.type=='4'}">
            <span>{{item.name}}</span>
        </div>
        <img class="img" v-if="item.status == 'up'" :src="upImg" />
        <img class="img" v-if="item.status == 'down'" :src="dwonImg" />
        <img class="img" v-if="item.status == 'middle'" :src="middleImg" />
        <div class="num" v-if="item.status" :class="{istop: item.status == 'up', isdown: item.status == 'down', ismiddle: item.status == 'middle'}">{{item.number}}</div>
        <div v-if="!item.status" class="area">
            <span>中国：</span>
            <span :class="{activebuild: ranklist.type=='3', activehealth: ranklist.type=='4'}">{{item.number}}</span>
        </div>
        <div v-if="!item.status" class="area">
            <span>全球：</span>
            <span :class="{activebuild: ranklist.type=='3', activehealth: ranklist.type=='4'}">{{item.global_number}}</span>
        </div>
    </div>
    <div class="loadmore" @click="loadmore" v-if="!isHidden && ranklist.list.length >= 10">
        <div v-if="isLoadmore" style="display: flex;justify-content: center;align-items: center;">
            <span>
                展示更多
            </span>
            <img style="width:15px" src="@/assets/images/data/down2.jpg" alt="">
        </div>
        <div v-else style="display: flex;justify-content: center;align-items: center;">
            <span>
                收起
            </span>
            <img style="width:15px" src="@/assets/images/data/up2.jpg" alt="">
        </div>
    </div>
    <div class="curbottom" v-if="isHidden">
        <div class="botlayout">
            <div class="leftlayout isbuildleft" v-if="ranklist.type > 2">
                <div style="width:100%">
                    <!-- <div class="rankfont" @click="jumpDataList(ranklist.type, 4)">媒体报道</div> -->
                    <span class="news" @click="jumpDataList(ranklist.type, 4)">媒体报道</span>
                    <div>
                        <ul class="newul">
                            <li v-for="(mItem, index) in ranklist.media_coverage.data.list" :index="index" style="margin: 10px 0" @click="getGenDetail(mItem)">
                                {{ mItem.title }}
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <div class="leftlayout" v-if="ranklist.type <= 2">
                <div class="fontleft">
                    <div class="rankfont" @click="jumpDataList(ranklist.type, 1)">{{ranklist.theoretical_basis.title}}</div>
                    <div class="rankfont" @click="jumpDataList(ranklist.type, 2)">{{ranklist.annual_report.title}}</div>
                </div>
                <div>
                    <div class="rankfont" @click="jumpDataList(ranklist.type, 3)">{{ranklist.annual_ranking.title}}</div>
                    <div class="rankfont" @click="jumpDataList(ranklist.type, 4)">{{ranklist.media_coverage.title}}</div>
                </div>
            </div>
            <div class="rightlayout" :class="{ isbuildright: ranklist.type > 2 }">
                <div v-if="ranklist.type <= 2" style="text-align:center" @click="getCompleteRank(ranklist.type)">
                    <img class="rankpng" src="@/assets/images/data/rank.jpg" alt="">
                    <div>{{ranklist.complete_ranking.title}}</div>
                </div>
                <div @click="jumpSql">
                    <img class="rankpng" src="@/assets/images/data/sql.jpg" alt="">
                    <div>数据库</div>
                </div>
            </div>
        </div>
    </div>
  </div>
</template>

<script>
import { Toast } from 'mint-ui';
import envnetBus from '@/utils/eBus'
export default {
  data(){
    return {
        upImg:require('@/assets/images/data/up.jpg'),
        dwonImg:require('@/assets/images/data/down.jpg'),
        middleImg:require('@/assets/images/data/middle.jpg'),
        rankListChild: [],
        isLoadmore: true,
        allRanklist: []
    }
  },
  props: ['ranklist','isHidden'],
  mounted(){
    // console.log(this.ranklist)
    if (this.ranklist.type <= 2) {
        this.allRanklist = this.ranklist.list
        if (this.ranklist.list.length>=10) {
            this.rankListChild = this.ranklist.list.filter((item, index) => {
                return index <10
            })
        } else {
            this.rankListChild = this.ranklist.list
        }
    } else {
        if (this.ranklist.list.length>=10) {
            for (let i = 0; i < this.ranklist.list.length; i++) {
                this.rankListChild.push(this.ranklist.list[i])
            }
        } else {
            this.rankListChild = this.ranklist.list
        }
    }
  },
  methods:{
      getGenDetail(mitem) {
          this.$router.push({ name: 'newsDetail', query: { id: mitem.id } });
      },
      getCompleteRank(type) {
        envnetBus.$emit('goGreens', type)
      },
      getMediaNews() {
          this.$router.push({ name: 'dataDetail', query: { dataDetail: 'dataDetail',id: 1, typeid: 4} })
      },
      getDetail(item, type) {
          let typid = this.$route.query.cate_id;
          console.log(typid)
          if (typid == undefined) {
              if (type == '1') {
                  typid = '101'
              } else {
                  typid = '102'
              }
          }
          if (type == '1' || type == '2') {
            sessionStorage.clear()
            this.$router.push({ name: 'dataDetail', query: { dataDetail: 'dataDetail',id: item.id, typeid: typid} })
          }
      },
      loadmore(){
          if (this.isLoadmore) {
            this.rankListChild = this.allRanklist
          } else{
              this.rankListChild = this.ranklist.list.filter((item, index) => {
                  return index <10
              })
          }
          this.isLoadmore = !this.isLoadmore
      },
      jumpDataList(type, id) {
        this.$router.push({ name: 'dataList', query: { id: id, type: type } })
      },
      jumpSql(){
          const vipType = JSON.parse(localStorage.getItem('user'))
            if (vipType) {
                if (vipType.is_vip == '0') {
                    Toast({
                        message: '详细数据库只对VIP会员开放，请先成为VIP会员',
                        position: 'middle',
                        duration: 2000
                    });
                this.$router.push({ path: '/open' })
                } else {
                    Toast({
                        message: 'VIP会员，正在进入数据库...',
                        position: 'middle',
                        duration: 2000
                    });
                    envnetBus.$emit('loginDataBase',false)
                }
            } else {
                Toast({
                message: '请先登录/注册',
                position: 'middle',
                duration: 2000
                });
                this.$router.push({ path: '/login' })
            }
      }
  }

}
</script>

<style  lang="stylus" scoped>
#ranking{
    padding-top:30px;
    .listitem{
        font-size: 30px;
        height:50px;
        display: flex;
        justify-content: center;
        align-items: center;
        margin:20px 0;
        padding: 0 60px;
        .indexpoint{
            width: 40px;
            height: 40px;
            display: flex;
            justify-content: center;
            align-items: center;
            border-radius: 40px;
            background-color: #e2eef7;
            margin-right: 20px;
        }
        .isone{
            background-color: #ffeb00;
        }
        .istwo{
            background-color: #fff370;
        }
        .isthree{
            background-color: #fed88c;
        }
        .name{
            width: 200px;
            flex: 1;
            font-weight: bold;
        }
        .activecolor{
            color:#5B9BD5;
        }
        .img{
            width:30px;
        }
        .num{
            width:100px;
            color:#5B9BD5;
            font-weight: 600;
            margin-left: 40px;
        }
        .istop{
            color: #c00000;
        }
        .isdown{
            color: #92d050;
        }
        .ismiddle{
            color: #a6a6a6;
        }
        .activebuild{
            color: #e3a702;
            // span{
            //     display: inline-block;
            //     background-color:#993CA4;
            //     padding: 5px;
            //     white-space: nowrap;
            //     text-overflow: ellipsis;
            //     overflow: hidden;
            //     width: 250px;
            //     border-radius: 10px;
            //     text-align: center;
            // }
        }
        .activehealth{
            color: #b17d2d;
        }
        .area{
            width: 180px;
        }
    }
    .loadmore{
        color: #91ca2e;
        width:100%;
        height:50px;
        line-height:50px;
        margin-top:30px;
        // background-color:#f2f2f2;
        background-image: linear-gradient(#e8f9c7, #fdfff7);
        border-bottom-left-radius: 20px;
        border-bottom-right-radius: 20px;
        text-align:center;
    }
    // .loadmore::after{
    //     content:url('../assets/images/data/down2.jpg');
    //     width:20px;
    //     height:20px;
    // }
    .curbottom{
        display:block;
        margin-top 80px;
        .botlayout{
            margin: 0 5%;
            overflow: hidden;
            padding: 50px 0;
            border-top: solid 1px #d9d9d9;
            display: flex;
            justify-content: space-evenly;
            align-items: center;
            .leftlayout{
                position:relative;
                width: 50%;
                float: left;
                display: flex;
                justify-content: space-evenly;
                .fontleft{
                    float: left;
                    margin-right: 20px;
                }
                .rankfont{
                    margin: 18px 0;
                    font-size:25px;
                    background-color: #efefef;
                    padding: 15px 20px;
                    border-radius: 8px;
                }
                .news{
                   color: #ffffff;
                   background-color: #aaaaaa;
                   padding: 10px;
                   margin-bottom: 5px;
                   margin-left: 5px;
                   border-radius: 8px;
                }
                .newul{
                    border-radius: 10px;
                    padding: 15px 20px;
                    background-color: #f2f2f2;
                    margin-top: 8px;
                    li{
                        margin: 5px;
                    }
                }
            }
            .rightlayout{
                padding-left: 30px;
                width: 50%;
                display: flex;
                justify-content: inherit;
                text-align: center;
                .rankpng{
                    width:50px;
                }
            }
            .isbuildleft{
                width: 70%;
            }
            .isbuildright{
                width: 30%;
            }
        }
    }
}
</style>